var generateStoreApi = require('./src/storage');

module.exports = generateStoreApi;